import { Switch, Route } from "react-router-dom";
import ModuloADS from "../../Pages/ModuloAds";
import AnaliseDeCredito from "../../Pages/Vendas/AnaliseDeCredito";
import AtendimentoVendas from "../../Pages/Vendas/AtendimentoVendas";
import { GestaoAtendimentoVendas } from "../../Pages/Vendas/GestaoAtendimentos";
import GestaoDeVisitas from "../../Pages/Vendas/GestaoDeVisitas";
import GestaoConfigDeEnvelope from "../../Pages/Vendas/GestaoConfigDeEnvelope";
import GestaoReservas from "../../Pages/Vendas/GestaoReservas";
import PainelImplantacao from "../../Pages/Vendas/PainelImplantacao";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import EspelhoVendas from "../../Pages/Vendas/EspelhoVendas";
import GestaoCadastro from "../../Pages/Vendas/GestaoDeCadastro";
import GestaoVistoriaEquipeProduto from "../../Pages/Vendas/GestaoVincularProdutos";

export default function RotasVendas() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.DASHBOARD.DS_PATH}
                component={() => <></>}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH}
                component={GestaoAtendimentoVendas.TodosAtendimentos}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.TODOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.GRUPO.DS_PATH}
                component={GestaoAtendimentoVendas.GrupoAtendimentos}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.GRUPO.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                        .DS_PATH
                }
                component={GestaoAtendimentoVendas.MeusAtendimentos}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                        .USUARIO.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.DS_PATH}
                component={AnaliseDeCredito}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS.DS_PATH}
                component={GestaoReservas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.CRIAR_EQUIPE_VENDA
                        .DS_PATH
                }
                component={GestaoCadastro}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.CRIAR_EQUIPE_VENDA
                        .ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.VINCULAR_PRODUTO_VENDA
                        .DS_PATH
                }
                component={GestaoVistoriaEquipeProduto}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.VINCULAR_PRODUTO_VENDA
                        .ID_TELA
                }
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.PRODUTOS.TELAS.PAINEL_IMPLANTACAO.DS_PATH}
                component={PainelImplantacao}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.PRODUTOS.TELAS.PAINEL_IMPLANTACAO.ID_TELA
                }
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_VISITAS.DS_PATH}
                component={GestaoDeVisitas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_VISITAS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_PATH}
                component={AtendimentoVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.ATENDIMENTO.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.DS_PATH}
                component={EspelhoVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_CONFIG_ENVELOPES.DS_PATH}
                component={GestaoConfigDeEnvelope}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_CONFIG_ENVELOPES.ID_TELA}
            />
            <Route path="/Vendas/:idModulo/" exact component={ModuloADS} />
        </Switch>
    );
}
